import {
  LpFeeType,
  LpFeeCalculationBasis,
  LpArrearsCalculation,
  LpFeeStartDate,
  FeeApportionmentBasis,
  LpAccrualFrequency,
  LpFeeCommitmentStatus,
} from 'further-types/lp/lp-fee-template';
import { FeesEqualisationTreatment } from 'further-types/lp/equalisation';

type RecurringPercentageFee = {
  name: string;
  type: LpFeeType.RecurringPercentage;
  calculationBasis: LpFeeCalculationBasis;
  accrualFrequency: LpAccrualFrequency;
  startPeriod: number;
  endPeriod: number;
  commitmentStatus: LpFeeCommitmentStatus;
  feeExTax: number;
  salesTaxRate: number;
};

export const emptyFee: RecurringPercentageFee = {
  name: '',
  type: LpFeeType.RecurringPercentage,
  calculationBasis: LpFeeCalculationBasis.CommittedCapital,
  accrualFrequency: LpAccrualFrequency.QuarterlyAdvance,
  startPeriod: 1,
  endPeriod: 1,
  commitmentStatus: LpFeeCommitmentStatus.InsideCommitment,
  feeExTax: 0,
  salesTaxRate: 0,
};

export const createEmptyFeeTemplate = (isDefaultFeeTemplate: boolean) => {
  const feesEqualisationTreatment: FeesEqualisationTreatment.Full =
    FeesEqualisationTreatment.Full;
  return {
    name: '',
    isDefaultFeeTemplate,
    feeApportionmentBasis: FeeApportionmentBasis.ActualActual,
    arrearsCalculation: LpArrearsCalculation.BasedOnPeriodEndingAmount,
    feeStartDate: LpFeeStartDate.FundFirstCloseDate,
    feesEqualisationTreatment,
    lpFeeTemplateFees: [{ ...emptyFee }],
  };
};
